import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function SkeletonBlock({
  className,
  width,
  height,
  maxWidth,
  maxHeight,
  minWidth,
  minHeight
}) {
  return (
    <div
      className={classnames(
        'SkeletonBlock bg-gray-200 bg-loading-animation br1',
        className
      )}
      style={{ width, height, maxWidth, maxHeight, minWidth, minHeight }}
    />
  );
}

SkeletonBlock.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

SkeletonBlock.defaultProps = {
  className: null,
  width: null,
  height: null,
  maxWidth: '100%',
  maxHeight: '100%',
  minWidth: null,
  minHeight: null
};
